var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('div',{staticClass:"d-flex flex-row bd-highlight align-items-center post mx-auto"},_vm._l((_vm.item),function(list,i){return _c('div',{key:i,staticClass:"p-3 bd-highlight late",class:{'test': list.short_name===_vm.choose },on:{"click":function($event){return _vm.changeMe(list.short_name)}}},[_vm._v(_vm._s(list.long_name))])}),0),_vm._v(" "),_c('div',{staticClass:"strikeMe mx-auto"})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ab98da7","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/page4/post.vue
// module id = 656
// module chunks = 0